import { ArrowUpDown, ChevronDown, ChevronUp } from 'lucide-react'

export type SortDir = 'asc' | 'desc'
export interface SortState<K extends string> {
  key: K
  dir: SortDir
}

/** Classe dos `<th>` das tabelas de lista (Atendimento HUB, Ocorrências). */
export const TH_CLASS = 'whitespace-nowrap px-4 py-3.5 font-semibold'

/** Ciclo do clique no cabeçalho, igual à planilha de processos:
 * asc → desc → sem ordenação. */
export function nextSort<K extends string>(
  current: SortState<K> | null,
  key: K,
): SortState<K> | null {
  if (current?.key !== key) return { key, dir: 'asc' }
  return current.dir === 'asc' ? { key, dir: 'desc' } : null
}

/** Cabeçalho ordenável (ver `nextSort`). */
export function SortableTh({
  label,
  dir,
  onToggle,
  center = false,
}: {
  label: string
  dir: SortDir | null
  onToggle: () => void
  /** Centraliza o rótulo — para colunas de número curto (ex.: contagens). */
  center?: boolean
}) {
  return (
    <th
      className={center ? `${TH_CLASS} text-center` : TH_CLASS}
      aria-sort={
        dir === 'asc' ? 'ascending' : dir === 'desc' ? 'descending' : 'none'
      }
    >
      <button
        type="button"
        onClick={onToggle}
        title="Ordenar (clique novamente para inverter; 3º clique limpa)"
        className={`group inline-flex items-center gap-1 uppercase tracking-[0.06em] transition-colors hover:text-body ${
          dir ? 'text-blue-700 dark:text-blue-300' : ''
        }`}
      >
        {label}
        {dir === 'asc' ? (
          <ChevronUp className="h-3 w-3" strokeWidth={2.5} />
        ) : dir === 'desc' ? (
          <ChevronDown className="h-3 w-3" strokeWidth={2.5} />
        ) : (
          <ArrowUpDown className="h-3 w-3 opacity-0 transition-opacity group-hover:opacity-100" />
        )}
      </button>
    </th>
  )
}
